module.exports = __webpack_public_path__ + "static/media/01.8d6beb3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/01.jpg
// module id = 460
// module chunks = 0